import React from 'react';
import { View } from '@react-pdf/renderer';

interface PdfBreakProps {
	height?: number;
}

const PdfBreak = (props: PdfBreakProps) => {
	const {
		height = 18,
	} = props;

	return (
		<View style={{ height: height }} />
	);
};

export default PdfBreak;
